function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { isNativeFlutterApp } from 'app/helpers/nativeHelpers';
import { Popper } from '@mui/material';
import React from 'react';
import { getUserAgentData } from 'app/helpers/helpers';
const modifiersToFixScrollingPopperInMobileBrowser = [{
  name: 'flip',
  enabled: true,
  options: {
    altBoundary: true,
    rootBoundary: 'document',
    padding: 8
  }
}, {
  name: 'preventOverflow',
  enabled: true,
  options: {
    altAxis: true,
    altBoundary: true,
    tether: true,
    rootBoundary: 'document',
    padding: 8
  }
}];
export const CustomPopperComponent = props => {
  const {
    deviceType
  } = getUserAgentData();
  const modifiers = deviceType === 'mobile' && !isNativeFlutterApp() ? modifiersToFixScrollingPopperInMobileBrowser : [];
  return /*#__PURE__*/React.createElement(Popper, _extends({}, props, {
    modifiers: modifiers,
    "data-sentry-element": "Popper",
    "data-sentry-component": "CustomPopperComponent",
    "data-sentry-source-file": "CustomPopperComponent.tsx"
  }));
};